import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { Empty, PageHeader } from "antd";
import { setRoute } from "scripts/reducer";
import Resources from "scripts/resources";

const EmptyPage = (props) => {
  const { pathname } = useLocation();

  const componentDidUpdate = () => {
    const { onSetRoute, routeName, parentName } = props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });
  };

  useEffect(componentDidUpdate, [pathname]);

  return (
    <>
      <PageHeader title={Resources.comingSoon} />
      <Empty />
    </>
  );
};

export default connect(null, (dispatch) => {
  return {
    onSetRoute: (data) => dispatch(setRoute(data)),
  };
})(EmptyPage);
